import AccountService from "../../Services/AccountService";

export const FETCH_ACCOUNTS_REQUEST = "FETCH_ACCOUNTS_REQUEST";
export const FETCH_ACCOUNTS_SUCCESS = "FETCH_ACCOUNTS_SUCCESS";
export const FETCH_ACCOUNTS_FAILURE = "FETCH_ACCOUNTS_FAILURE";

export const FETCH_ACCOUNTS_COUNT_REQUEST = "FETCH_ACCOUNTS_COUNT_REQUEST";
export const FETCH_ACCOUNTS_COUNT_SUCCESS = "FETCH_ACCOUNTS_COUNT_SUCCESS";
export const FETCH_ACCOUNTS_COUNT_FAILURE = "FETCH_ACCOUNTS_COUNT_FAILURE";

export const fetchAccounts = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_ACCOUNTS_REQUEST });
    try {
        const response = await AccountService.AccountList(payload);
        dispatch({ type: FETCH_ACCOUNTS_SUCCESS, payload: response.data });
    }
    catch (error) {
        dispatch({ type: FETCH_ACCOUNTS_FAILURE, payload: error.message });
    }
}

export const fetchAccountsCount = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_ACCOUNTS_COUNT_REQUEST });
    try {
        const response = await AccountService.AccountListTotalCount(payload);
        dispatch({ type: FETCH_ACCOUNTS_COUNT_SUCCESS, payload: response.data.TOTAL_COUNT_STATUS });
    }
    catch (error) {
        dispatch({ type: FETCH_ACCOUNTS_COUNT_FAILURE, payload: error.message });
    }
}